import { authenticatedApi } from './api';

const API_ADS_PATH = '/ads';

export const fetchOne = async () => authenticatedApi.get(API_ADS_PATH);
